import React, { useContext, useRef } from "react";
import BemIt, { addClass } from "@gtechdoodler/bem-it";
import GridColumn from "./GridColumn/GridColumn";
import StyledGrid from "./Grid.styles";
import useViewport from "../../../hooks/useViewport";
import { GridProps, GridSubComponents } from "./Grid.types";
import { resolveGuttersSpaceOption } from "./functions/resolveGuttersSpaceOption";
import { ViewportSsrContext } from "../../../hooks/useViewport/ViewportSsrContext";

const Grid: React.FC<GridProps> & GridSubComponents = ({
	className,
	gutters,
	colGutters,
	rowGutters,
	...props
}) => {
	const block = new BemIt("Grid");
	const gridRef = useRef(null);
	const vp = useViewport();
	const contextBreakpoint = useContext(ViewportSsrContext);

	const resolvedColGutters = resolveGuttersSpaceOption(
		colGutters || gutters,
		contextBreakpoint,
		vp
	);
	const resolvedRowGutters = resolveGuttersSpaceOption(
		rowGutters || gutters,
		contextBreakpoint,
		vp
	);

	return (
		<StyledGrid
			ref={gridRef}
			className={addClass(className).after(block)}
			colGutters={resolvedColGutters}
			rowGutters={resolvedRowGutters}
			suppressHydrationWarning
			{...props}
		>
			{props.children}
		</StyledGrid>
	);
};

Grid.Column = GridColumn;

export default Grid;
